/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { pairwise } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config/app-config-service';
import { Themes } from './themes.enum';

@Injectable({ providedIn: 'root' })
export class ThemeService {
   constructor(private appConfigService: AppConfigService) {}

   private adminToken = this.appConfigService.getConfig()?.adminToken;

   private currentTheme = new BehaviorSubject<Themes>(this.adminToken ? Themes.Default : Themes.Customer);

   currentTheme$ = this.currentTheme.pipe(pairwise());

   setTheme(theme: Themes) {
      this.currentTheme.next(theme);
   }
}
